import {compose as C, map as m, values,mean,subtract, pick, head, defaultTo, nth, append, uniq, curry, __, toPairs, filter as f, reduce, maxBy, multiply, times, prop as p} from "ramda";
import {r,abs,sqrt} from "./math";
const ztable = require('./z_scores.json');

export const the_mean = C(mean,m(Number),values)
export const stdev = curry((the_mean,x) => C(sqrt,mean,values,m(C(x => x*x,subtract(the_mean))))(x))

export const diff_from_mean = item_nr => (selected,country,data) => {
    const nth_item = C(defaultTo({}),nth(item_nr))(data)
    const selected_data = pick(selected,nth_item);
    const Mean = the_mean(selected_data)
    const std = stdev(Mean,selected_data)
    const normal = x => ztable[r(2,abs(x))];
    return C(
        m(x => normal((Number(x)-Mean)/std) * 2),
        pick(uniq(append(country,selected)))
    )(nth_item)
}

export const explain_mean = ({data,unit,diff,country,comparison,scale}) => {
    const selected_data = C(pick(__,data),uniq,append(country))(comparison);
    const value = r(1,selected_data[country]);
    const avg = C(r(1),the_mean)(selected_data);
    const min_val = r(1,Math.min(...values(selected_data)));
    const max_val = r(1,Math.max(...values(selected_data)));
    const std = r(2,stdev(avg,selected_data));
    const word = scale[Math.floor(diff/0.2)];

    return `Selected country's value is ${value} ${unit} and the comparison group average is ${avg} ${unit}. In current selection the smallest value is ${min_val} ${unit}, largest is ${max_val} ${unit}. Standard deviation is ${std} ${unit}. Relative difference measured in standard deviations assuming normal distribution of differences is therefore ${r(1,diff*100)} % which can be interpreted as ${diff <= 0.2 ? "among" : ""} ${word} (${Math.floor(diff/0.2)+1}/5) ${diff <= 0.2 ? "" : "from comparison group average"}.`
}

export const take_mean = (sel,country,data) => pick(
    uniq(append(country,sel)),
    data ? head(data) : {}
); 